import { fetch, Method} from 'core/api/fetch';

const TermsRoutes = {
    getExperiencesTerms: (experienceId) => `/api/v1.1.1/admin/experience/${experienceId}/ExperienceTerms`,
    savePDF: (experienceId) => `/api/v1.1.1/admin/experience/${experienceId}/ExperienceTerms`,
}


export const TermsService = {
     getExperiencesTerms: async (experienceId) => {
        try {
            const { data } = await fetch(TermsRoutes.getExperiencesTerms(experienceId), {
                method: Method.GET,
                authenticated: true,
            });

            if (!data?.experienceTerms || !data?.activeTerms) {
                return false;
            }

            return data;
        } catch (error) {
            throw new Error(error);
        }
    },
     savePDF: async (expId, newData) => {
        try {
            const formData = new FormData();
            formData.append('pdfFile', newData?.file);
            if (newData?.documentName) {
                formData.append('name', newData.documentName);
            }
            await fetch(TermsRoutes.savePDF(expId), {
                method: Method.POST,
                authenticated: true,
                data: formData,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return true;
        } catch (err) {
            console.error(err);
            return false;
        }
    },
};
